<template>
  <div class="invoice padding-50 sm-padding-10" v-if="current_order">
    <div>
      <div class="pull-left">
        <img width="235" alt="" class="invoice-logo" data-src-retina="~assets/img/logo-sofradom.png"
             data-src="~assets/img/logo-sofradom.png" src="~assets/img/logo-sofradom.png">
        <!-- <address class="m-t-10">
          SOFRADOM
          <br>+33 632 261 427
          <br>
        </address> -->
      </div>
      <div class="pull-right sm-m-t-20">
        <h2 class="font-montserrat all-caps hint-text">Commande</h2>
      </div>
      <div class="clearfix"></div>
    </div>
    <br>
    <br>
    <div class="container-sm-height" >
      <div class="row-sm-height">
        <div class="col-md-9 col-sm-height sm-no-padding">
          <p class="small no-margin">Client :</p>
          <h5 class="semi-bold m-t-0">{{current_order.customer.main_representative.decoded_civility}} {{current_order.customer.main_representative.first_name}} {{current_order.customer.main_representative.last_name}}</h5>
          <address>
            <ul>
              <li><strong>{{current_order.customer.decoded_civility}} {{current_order.customer.name}}</strong></li>
              <li><span>{{current_order.customer.main_address.street_line1}}</span></li>
              <li><span v-if="current_order.customer.main_address.street_line2">{{current_order.customer.main_address.street_line2}}</span></li>
              <li><span> {{current_order.customer.main_address.zipcode}} {{current_order.customer.main_address.city}}</span></li>
              <li><span v-if="current_order.customer.main_address.state"> {{current_order.customer.main_address.state}}</span><span>{{current_order.customer.main_address.decoded_country}}</span></li>
            </ul>
          </address>
        </div>
        <div class="col-md-3 col-sm-height col-bottom sm-no-padding sm-p-b-20">
          <br>
          <div>
            <div class="pull-left font-montserrat bold all-caps">N° :</div>
            <div class="pull-right">{{current_order.ihrez}}</div>
            <div class="clearfix"></div>
          </div>
          <div>
            <div class="pull-left font-montserrat bold all-caps">Le :</div>
            <div class="pull-right">{{current_order.updated_at | moment-date}}</div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table m-t-50">
        <thead>
        <tr>
          <th class="">Produit</th>
          <th class="text-right">Quantité</th>
          <th class="text-right">Total HT</th>
          <th class="text-right">TVA</th>
          <th class="text-right">Total TTC</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(suborder, idx) in current_order.suborders">
          <tr>
            <td class="">
              <p class="text-black"><strong>{{suborder.text}}</strong></p>
            </td>
            <td class="text-right">{{suborder.quantity}}</td>
            <td class="text-right">{{(suborder.price / 100).toFixed(2)}}€</td>
            <td class="text-right">{{(suborder.tax_amount / 100).toFixed(2)}}€</td>
            <td class="text-right">{{((suborder.price + suborder.tax_amount) / 100).toFixed(2)}}€</td>
          </tr>
          <tr v-for="(option, idx) in suborder.options">
            <td>
              <p class="text-black" style="padding-left:15px;">  <em>{{option.name}}</em></p>
            </td>
            <td class="text-right" v-if="option.default_price">
              {{option.default_price.base_quantity}}
            </td>
            <td class="text-right">
              {{(option.default_price.base_price / 100).toFixed(2)}}€
            </td>
            <td class="text-right">
              {{(option.pivot.tax_amount / 100).toFixed(2)}}€
            </td>
            <td class="text-right">
              {{((option.pivot.tax_amount + option.pivot.price) / 100).toFixed(2)}}€
            </td>
          </tr>
        </template>
        <!-- <tr>
          <td class="">
            <p class="text-black">Cross Heart Charity Branding</p>
          </td>
          <td class="text-right">$89.00</td>
          <td class="text-right">100</td>
          <td class="text-right">16€</td>
          <td class="text-right">$8,900.00</td>
        </tr>
        <tr>
          <td class="">
            <p class="text-black">iOs App</p>
          </td>
          <td class="text-right">$100.00</td>
          <td class="text-right">500</td>
          <td class="text-right">200€</td>
          <td class="text-right">$50,000.00</td>
        </tr> -->
        </tbody>
      </table>
    </div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <!--<div class="container-sm-height">
      <div class="row row-sm-height b-a b-grey">
        <div class="col-sm-2 col-sm-height col-middle p-l-25 sm-p-t-15 sm-p-l-15 clearfix sm-p-b-15">
          <h5 class="font-montserrat all-caps small no-margin hint-text bold">Total HT</h5>
          <h3 class="no-margin">$21,000.00</h3>
        </div>
        <div class="col-sm-5 col-sm-height col-middle clearfix sm-p-b-15">
          <h5 class="font-montserrat all-caps small no-margin hint-text bold">TVA</h5>
          <h3 class="no-margin">$645.00</h3>
        </div>
        <div class="col-sm-5 text-right bg-menu col-sm-height padding-15">
          <h5 class="font-montserrat all-caps small no-margin hint-text text-white bold">Total TTC</h5>
          <h1 class="no-margin text-white">$64,276.00</h1>
        </div>
      </div>
    </div>-->
    <div class="container-sm-height">
      <div class="total-wrapper">
        <div class="col-sm-2 col-sm-height col-middle p-l-25 sm-p-t-15 sm-p-l-15 clearfix sm-p-b-15 text-right ht-total">
          <h5 class="font-montserrat all-caps small no-margin hint-text bold">Total HT</h5>
          <h3 class="no-margin">{{(current_order.total_ht / 100).toFixed(2)}}€</h3>
        </div>
        <div class="col-sm-2 col-sm-height col-middle clearfix sm-p-b-15 text-right ht-total">
          <h5 class="font-montserrat all-caps small no-margin hint-text bold">TVA</h5>
          <h3 class="no-margin">{{((current_order.total_ttc - current_order.total_ht) / 100).toFixed(2)}}€</h3>
        </div>
      </div>
      <div class="total-wrapper">
        <div class="col-sm-4 col-sm-height col-middle p-l-25 sm-p-t-15 sm-p-l-15 clearfix sm-p-b-15 text-right ht-total">
          <h5 class="font-montserrat all-caps small no-margin hint-text bold">Dépot de garantie</h5>
          <h3 class="no-margin">{{(current_order.deposit_amount / 100).toFixed(2)}}€</h3>
        </div>
      </div>
      <div class="total-wrapper">
        <div class="col-sm-4 text-right bg-menu col-sm-height padding-15">
          <h5 class="font-montserrat all-caps small no-margin hint-text text-white bold">Total TTC</h5>
          <h1 class="no-margin text-white">{{(current_order.total_to_pay / 100).toFixed(2)}}€</h1>
        </div>
      </div>
    </div>
    <hr>
    <p class="small hint-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eum fugit magni quidem quod
      voluptas. A amet animi blanditiis culpa delectus dolore ea, incidunt molestiae placeat quas recusandae rem
      reprehenderit rerum sint sit sunt tempore voluptate. Ad adipisci aliquam amet animi assumenda culpa cupiditate
      dolor dolorem doloribus, eveniet excepturi, fugit, laudantium nihil odit porro possimus quae quis reiciendis
      repudiandae similique sit ut vel velit! Ab cum ex hic magnam quibusdam voluptate?</p>
    <br>
    <hr>
    <div>
      <img src="~assets/img/logo-sofradom.png" alt="logo" data-src="~assets/img/logo-sofradom.png" data-src-retina="~assets/img/logo-sofradom.png"
           width="100">
      <span class="m-l-70 text-black sm-pull-right">+33 632 261 427</span>
      <span class="m-l-40 text-black sm-pull-right">contact@sofradom.fr</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .total-wrapper {
    display:flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    .ht-total {
      border:1px solid #ddd;
      &:first-child {
        border-right: 0;
      }
    }
  }
</style>

<script type="text/babel">
  import {mapActions, mapState} from 'vuex'
  import { moduleName } from './tabs'
  import { resolveMutation } from 'store/modules/tabs/tabManagerFactory'
  import alternativeTab from 'mixins/alternativeTab'
  export default {
    name: "OrderInvoice",

    mixins: [ alternativeTab('customer', moduleName, 1) ],

    computed:{
      ...mapState('cash', ['orders_payable', 'orders_unpayable']),

    },

    methods:{
      ...mapActions('cash', ['ordersOfCustomer']),
    },

    data(){
      return {
        current_order:undefined
      }
    },

    created() {
      this.ordersOfCustomer({customer_id:this.$route.params.id, params:{paginate:0}})
    },

    watch :{
      orders_payable : function() {
        this.current_order = _.find(this.orders_payable, (op) => op.id == Number(this.$route.params.orderId))
      }
    },
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/OrderInvoice.vue